import { LogLevel } from "@azure/msal-browser";
import type { AuthError, AuthenticationResult } from "@azure/msal-browser";

export const getMsalConfig = (clientId: string, authority: string, tokenScope: string) => ({
  auth: {
    clientId: clientId || "DUMMY",
    authority,
    redirectUri: window.location.origin + "/oauth",
    postLogoutRedirectUri: window.location.origin,
    onAuthentication: (_ctx: object, error: AuthError | null, _response: AuthenticationResult | null) => {
      if (error) {console.error("[MSAL] Authentication error:", error);}
    },
    onToken: (_ctx: any, _error: AuthError | null, _response: AuthenticationResult | null) => {},
    beforeSignOut: () => {},
    onLogError: (error: string) => {
      console.error("[MSAL]", error);
    }
  },
  cache: {
    cacheLocation: "localStorage"
  },
  loginRequest: {
    scopes: ["openid", "profile", "User.Read", tokenScope].filter(Boolean)
  },
  tokenRequest: {
    scopes: [tokenScope]
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {return;}
        switch (level) {
          case LogLevel.Error:
            console.error("[MSAL]", message);

            return;
          case LogLevel.Warning:
            console.warn("[MSAL]", message);

            return;
          case LogLevel.Info:
            console.info("[MSAL]", message);

            return;
          case LogLevel.Verbose:
            console.debug("[MSAL]", message);

            return;
        }
      }
    }
  }
});
